import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../../store/languageContext';
import { motion } from 'framer-motion'
import logo from '../../assets/images/logo.png'
import { Link } from 'react-router-dom';
import translate from '../../utils/translation';
const Footer = () => {
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [emailError, setEmailError] = useState('');
    const [mobileError, setMobileError] = useState('');
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const handleSubmit = (e) => {
        e.preventDefault();
        let valid = true;
        if (!email.trim()) {
            setEmailError('Email is required');
            valid = false;
        } else {
            setEmailError('');
        }
        if (!mobile.trim()) {
            setMobileError('Phone number is required');
            valid = false;
        } else {
            setMobileError('');
        }
        if (valid) {
            // Handle form submission here (e.g., API call)
            console.log('Submitting form:', { email, mobile });
            // Reset fields if needed
            setEmail('');
            setMobile('');
        }
    };
    return (
        <footer ref={sectionRef} className="landing-section flex flex-col bg-[#111]">
            <motion.div
                initial={{ y: 100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.7, ease: 'easeOut' }}
                viewport={{ once: true }}
                className="container mx-auto flex flex-col justify-center flex-1 text-white">
                <div className='flex justify-between flex-1 items-center'>
                    <ul className='flex flex-col gap-4'>
                        <h4 className='uppercase font-semibold opacity-50 text-lg mb-4'>
                            {translate[language]['QuickLinks']}
                        </h4>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#advantages">
                                {translate[language]['advantagesHeader']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#services">
                                {translate[language]['servicesHeader']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#how-it-works">
                                {translate[language]['howHeader']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#latest">
                                {translate[language]['latestHeader']}
                            </a>
                        </li>
                    </ul>
                    <ul className='flex flex-col gap-4'>
                        <h4 className='uppercase font-semibold opacity-50 text-lg mb-4'>
                            {translate[language]['Social']}
                        </h4>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#home">
                                {translate[language]['Facebook']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#home">
                                {translate[language]['Instagram']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#home">
                                {translate[language]['Youtube']}
                            </a>
                        </li>
                        <li className='text-md hover:underline font-semibold'>
                            <a href="#home">
                                {translate[language]['Twitter']}
                            </a>
                        </li>
                    </ul>
                    <div className='flex flex-col gap-4'>
                        <h4 className='uppercase font-semibold opacity-50 text-lg mb-4'>
                            {translate[language]['BookCall']}
                        </h4>
                        <div className='text-md font-semibold'>
                            {translate[language]['BookText']}
                        </div>
                        <form onSubmit={handleSubmit} className={`flex gap-5 ${language === 'ar' ? 'text-right' : ''}`}>
                            <div className='flex flex-col'>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    className={`bg-transparent border-b py-3 !outline-none ${language === 'ar' ? 'text-right' : ''}`}
                                    placeholder={translate[language]['Email']}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {emailError && <p className="text-red-500 text-sm">{emailError}</p>}
                            </div>
                            <div className='flex flex-col'>
                                <input
                                    type="tel"
                                    name="mobile"
                                    id="mobile"
                                    className={`bg-transparent border-b py-3 !outline-none ${language === 'ar' ? 'text-right' : ''}`}
                                    placeholder={translate[language]['Phone']}
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                                {mobileError && <p className="text-red-500 text-sm">{mobileError}</p>}
                            </div>
                            <button className='py-2 px-4 bg-[#589EEE] hover:bg-[#589eee91] rounded-full font-semibold hover:text-white duration-300' type='submit'>{translate[language]['BookCall']}</button>
                        </form>
                    </div>
                </div>
                <div className='flex justify-between flex-1'>
                    <Link to="/" className="text-2xl font-bold chewy-regular flex items-center">
                        <img src={logo} alt="logo" className={`size-[200px] min-w-[200px] filter duration-500 brightness-0 invert`} />
                    </Link>
                    <div className='flex flex-col justify-center opacity-50 uppercase text-sm '>
                        <p className='mb-4'>
                            {translate[language]['Copyright']}
                        </p>
                        <div className='flex gap-3'>
                            <a href="/" className='hover:underline'>
                                {translate[language]['Privacy']}
                            </a>
                            <a href="/" className='hover:underline'>
                                {translate[language]['Terms']}
                            </a>
                        </div>
                    </div>
                </div>
            </motion.div>
        </footer>
    );
};

export { Footer };